import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import { ReactElement } from 'react';
import { Tag } from '.';
import { Link } from 'react-router-dom';

/**
 * The includeGuarded query parameter
 *
 * Every endpoint that returns item data accepts this, so it's documented in
 * one place to keep the wording consistent
 */
export function IncludeGuardedParameter(): ReactElement {
  return (
    <li>
      <Tag intent="warning" icon={faQuestion} show>
        optional
      </Tag>
      <code className="attribute">
        includeGuarded
        <span className="attribute-type">boolean</span>
      </code>
      <code className="attribute-example">?includeGuarded=true</code>
      <span className="attribute-description">
        <p>
          Include values hidden by{' '}
          <Link to="/docs/indexing#guard-indexes">guard indexes</Link>{' '}
          in the response. Can be <code>true</code> or <code>false</code>.
        </p>
        <p>
          This only applies when the request is authenticated as an identity,
          and only to the items that identity owns. Without an identity, guarded
          values stay hidden.
        </p>
        <p>
          Defaults to <code>false</code>.
        </p>
      </span>
    </li>
  );
}
